import React from 'react';
import { Form, Field } from 'react-final-form';
import { useDisplayCurrency } from '../../context/displayCurrencyContext';
import { LOCAL_CURRENCIES } from '../../util/localCurrency';
import { useIntl } from '../../util/reactIntl';
import css from './CurrencySelector.module.css';

/** A visible manual override for automatic regional currency selection. */
export default function CurrencySelector() {
  const { currency, setCurrency } = useDisplayCurrency();
  const intl = useIntl();
  return (
    <Form
      initialValues={{ currency }}
      onSubmit={() => {}}
      render={() => (
        <Field
          name="currency"
          render={({ input }) => (
            <select
              {...input}
              className={css.selector}
              aria-label={intl.formatMessage({ id: 'LocalCurrency.selector' })}
              onChange={event => {
                input.onChange(event);
                setCurrency(event.target.value);
              }}
            >
              {LOCAL_CURRENCIES.map(code => (
                <option className={css.option} key={code} value={code}>
                  {code}
                </option>
              ))}
            </select>
          )}
        />
      )}
    />
  );
}
